export enum DelayFailureAccountabilityEnum {
  Engineius = 1,
  Customer = 2,
  Supplier = 3,
}
